import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Switch, Tooltip, message } from 'antd';
import { BENEFIT } from '../../../../constants/define/translation';
import { BenefitType } from '../../../../types/benefit';
import { putUpdateBenefitRepository } from '../../../../repository/mytm/benefit/benefitRepository';
import { btnActive } from '../../../../styles';

interface ActionsColumnProps {
  record: BenefitType;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(BENEFIT);
  const { record, onRefresh } = props;

  const [showHideLoading, setShowHideLoading] = useState(false);

  const onShowHideCard = () => {
    const payload: any = {
      id: record.id,
      disabled: !record.disabled,
      title: record.title,
      partnerId: record.partnerId,
      url: record.url,
      imageUrl: record.imageUrl,
      buttonList: record.buttonList,
      buttonDetail: record.buttonDetail,
      linkType: record?.linkType,
    };
    Modal.confirm({
      title: t('table.popup.title'),
      okText: t('table.popup.okBtn'),
      cancelText: t('table.popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: record.disabled ? <p>{t('table.popup.enable')}</p> : <p>{t('table.popup.disable')}</p>,
      onOk() {
        setShowHideLoading(true);
        putUpdateBenefitRepository({ ...payload })
          .then(r => {
            onRefresh();
          })
          .catch(e => {
            message.error(e?.errorMessage);
          })
          .finally(() => {
            setShowHideLoading(false);
          });
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={record.disabled ? t('table.tooltip.active') : t('table.tooltip.inactive')}>
          <Switch
            checked={!record.disabled}
            onChange={onShowHideCard}
            disabled={showHideLoading}
            loading={showHideLoading}
          />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
